module.exports = __webpack_public_path__ + "img/banner01.aa0e62e3.webp";